import React from "react";
import { Component } from "react";
import { ObjectLiteral } from "../../constants";
import _ from "lodash";
import { ReactCookieProps, withCookies } from "react-cookie";
import * as Sentry from "@sentry/nextjs";
import ShowError from "./ShowError";
import { Props } from "../propTypes";
import { childFormComponent } from "./types";
import { ResetForm } from "./ResetForm";

// Confirmation Component
/**
 * This component is used to display a confirmation for the user to verify their information
 * or an error if there is no data.
 */

class Confirmation extends Component<
    Props & childFormComponent & ReactCookieProps
> {
    componentDidMount() {
        if (
            (!_.isObject(this.props.main.userData) ||
                _.isEmpty(this.props.main.userData)) &&
            this.props.cookies &&
            this.props.registrationType &&
            this.props.cookies.get(
                "confirmation_" + this.props.registrationType.toLowerCase()
            )
        ) {
            this.props.logError &&
                this.props.logError(
                    "Empty User Data",
                    Sentry.Severity.Fatal,
                    null
                );

            this.props.cookies.remove(
                "confirmation_" + this.props.registrationType.toLowerCase(),
                { path: "/" }
            );
        }
    }

    render() {
        let data: ObjectLiteral = {};

        if (_.isObject(this.props.main.userData)) {
            data = this.props.main.userData;
        }

        if (_.isEmpty(data)) {
            if (
                this.props.renderCustomUserNotFound &&
                _.isFunction(this.props.renderCustomUserNotFound)
            ) {
                return this.props.renderCustomUserNotFound();
            }

            return (
                <>
                    <ShowError />
                    <ResetForm
                        idPrefix={`${this.props.tagPrefixId}-confirmation-error`}
                        cancelUrl={this.props.cancelUrl || ""}
                    />
                </>
            );
        } else if (
            this.props.renderConfirmation &&
            _.isFunction(this.props.renderConfirmation)
        ) {
            return (
                <>
                    {this.props.renderConfirmation(
                        data,
                        this.props.nextStep,
                        this.props.values
                    )}
                    <ResetForm
                        idPrefix={`${this.props.tagPrefixId}-confirmation`}
                        cancelUrl={this.props.cancelUrl || ""}
                    />
                </>
            );
        }
    }
}

export default withCookies(Confirmation);
